import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToolsRoutingModule } from './tools-routing.module';
import {ToolsViewComponent} from "./tools-view/tools-view.component";
import {ToolsEditComponent} from "./tools-edit/tools-edit.component";
import {ToolsComponent} from "./tools.component";
import {MatComponentsModule} from "../mat-components/mat-components.module";
import {FormsModule} from "@angular/forms";
import {MATERIAL_MODULES} from "../app.const";
import {PipesModule} from "../pipes/pipes.module";
import {FilesModule} from "../files/files.module";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { ToolsFilterComponent } from './tools-filter/tools-filter.component';
import {DirectivesModule} from "../directives/directives.module";
import {UtilsModule} from "../utils/utils.module";
import {SharedModule} from "../shared/shared.module";

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatMenuModule,
        MatComponentsModule,
        FormsModule,
        ...MATERIAL_MODULES,
        PipesModule,
        FilesModule,
        ToolsRoutingModule,
        DirectivesModule,
        UtilsModule,
        SharedModule
    ],
    declarations: [
        ToolsComponent,
        ToolsViewComponent,
        ToolsEditComponent,
        ToolsFilterComponent
    ]
})
export class ToolsModule { }
